import { Typography } from "@suraasa/placebo-ui"
import NeedHelpBanner from "features/Home/NeedHelpBanner"
import { useEnrollments } from "utils/hooks/useEnrollments"

const ForYou = () => {
  const { hasLearningPrograms } = useEnrollments()

  // Keep in sync with NeedHelpBanner's own gating so this heading never
  // renders with nothing under it.
  if (!hasLearningPrograms) return null

  return (
    <div>
      <Typography variant="subtitle2" className="mb-1.5 font-semibold">
        For You
      </Typography>
      <NeedHelpBanner />
    </div>
  )
}

export default ForYou
